module.exports = __webpack_public_path__ + "static/img/20260605_1.da22045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20260605_1.jpg
// module id = gKDC
// module chunks = 99